module.exports = __webpack_public_path__ + "img/screenshot-code-flat.ba812a1f.png";